__turbopack_context__.v({
  "detailsContainer": "details-module-scss-module__8Wuhpa__detailsContainer",
  "dotsList": "details-module-scss-module__8Wuhpa__dotsList",
  "exploreButton": "details-module-scss-module__8Wuhpa__exploreButton",
  "featuresButton": "details-module-scss-module__8Wuhpa__featuresButton",
  "headerWrapper": "details-module-scss-module__8Wuhpa__headerWrapper",
  "img": "details-module-scss-module__8Wuhpa__img",
  "title": "details-module-scss-module__8Wuhpa__title",
});
